import { render } from "./IconTextButton.vue?vue&type=template&id=51e26236&ts=true"
import script from "./IconTextButton.vue?vue&type=script&lang=ts"
export * from "./IconTextButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__